export const SUGGESTED_ANALYSES = [
    {
        id: 'risks',
        title: 'Surface key risks',
        prompt: 'Review the selected journal entries and list the key risks, open issues, and blockers. Group by theme and note which entries they come from.',
    },
    {
        id: 'actions',
        title: 'Extract open actions',
        prompt: 'Extract open action items and follow-ups from the selected journal entries. Include owners and dates when mentioned.',
    },
    {
        id: 'summary',
        title: 'Summarise recent progress',
        prompt: 'Summarise recent progress across the selected journal entries. Highlight decisions made, work completed, and what remains open.',
    },
    {
        id: 'meeting',
        title: 'Meeting digest',
        prompt: 'Create a concise meeting-style digest from the selected journal entries: decisions, discussion themes, and next steps.',
    },
];

export function groupChatsByRecency(chats) {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const sevenDaysAgo = new Date(startOfToday);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    const groups = { today: [], week: [], older: [] };
    (chats || []).forEach(chat => {
        const updated = new Date(chat.updated_at || chat.created_at);
        if (Number.isNaN(updated.getTime())) {
            groups.older.push(chat);
            return;
        }
        if (updated >= startOfToday) groups.today.push(chat);
        else if (updated >= sevenDaysAgo) groups.week.push(chat);
        else groups.older.push(chat);
    });
    return groups;
}

export function formatRelativeChatTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    const diffMs = Date.now() - date.getTime();
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins} min${mins === 1 ? '' : 's'} ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`;
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

/** Message timestamp like "11:40 AM" */
export function formatMessageTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

export function getAuthorInitials(fullName) {
    if (!fullName || typeof fullName !== 'string') return '?';
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
}
